import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';


@Pipe({
    name: 'mask'
})
export class MaskPipe implements PipeTransform {

    transform(value: string): string {
        if (!value) return '';
        let visibleChars = Math.floor(value.length/2);
        const maskedPart = '*'.repeat(value.length - visibleChars);
        const visiblePart = value.slice(-visibleChars);
        return maskedPart + visiblePart;
      }
}